import React from 'react';
import CompanyService from '../../../services/CompanyService';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import CrudManager from '../../../components/common/CrudManager';
import CompanyForm from './CompanyForm';

const Company = () => {

  const columns = [
    {
      key: 'logoImage',
      label: 'company.themes.logo',
      type: 'file',
      accept: 'image/*',
      sortable: false
    },
    {
      key: 'name',
      label: 'company.name',
      sortable: true,
      showInFilter: true,
      filterSize: 'large'
    },
    {
      key: 'displayName',
      label: 'company.displayName',
      sortable: true
    },
    {
      key: 'email',
      label: 'company.email',
      sortable: true
    },
    {
      key: 'enabled',
      label: 'company.enabled',
      showInGrid: false,
      showInFilter: true,
      filterType: 'checkbox',
      filterSize: 'small'
    }
  ];

  return (
    <CrudManager
      service={CompanyService}
      columns={columns}
      entityName="company"
      icon={faBuilding}
      customFormComponent={CompanyForm}
    />
  );
};

export default Company;

